import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enAuth from "./locales/en/auth.json";
import enBilling from "./locales/en/billing.json";
import enCommon from "./locales/en/common.json";
import enDashboard from "./locales/en/dashboard.json";
import enLanding from "./locales/en/landing.json";
import enMessages from "./locales/en/messages.json";
import enOnboarding from "./locales/en/onboarding.json";
import enPayments from "./locales/en/payments.json";
import enProfile from "./locales/en/profile.json";
import enSearch from "./locales/en/search.json";
import enSettings from "./locales/en/settings.json";
import enShifts from "./locales/en/shifts.json";
import enSurvey from "./locales/en/survey.json";
import enValidation from "./locales/en/validation.json";

import esAuth from "./locales/es/auth.json";
import esBilling from "./locales/es/billing.json";
import esCommon from "./locales/es/common.json";
import esDashboard from "./locales/es/dashboard.json";
import esLanding from "./locales/es/landing.json";
import esMessages from "./locales/es/messages.json";
import esOnboarding from "./locales/es/onboarding.json";
import esPayments from "./locales/es/payments.json";
import esProfile from "./locales/es/profile.json";
import esSearch from "./locales/es/search.json";
import esSettings from "./locales/es/settings.json";
import esShifts from "./locales/es/shifts.json";
import esSurvey from "./locales/es/survey.json";
import esValidation from "./locales/es/validation.json";

import "./dateLocale";
import { installZodErrorMap } from "./zodErrorMap";

export const LANG_STORAGE_KEY = "pm-lang";
export const SUPPORTED_LANGUAGES = ["en", "es"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    billing: enBilling,
    landing: enLanding,
    onboarding: enOnboarding,
    settings: enSettings,
    dashboard: enDashboard,
    messages: enMessages,
    payments: enPayments,
    shifts: enShifts,
    profile: enProfile,
    search: enSearch,
    survey: enSurvey,
    validation: enValidation,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    billing: esBilling,
    landing: esLanding,
    onboarding: esOnboarding,
    settings: esSettings,
    dashboard: esDashboard,
    messages: esMessages,
    payments: esPayments,
    shifts: esShifts,
    profile: esProfile,
    search: esSearch,
    survey: esSurvey,
    validation: esValidation,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as Array<string>,
    nonExplicitSupportedLngs: true,
    defaultNS: "common",
    ns: Object.keys(resources.en),
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

installZodErrorMap(i18n);

export default i18n;
